export default __webpack_public_path__ + "static/12-d7ee0ef88ef7985ae75553663f32afe9.jpg";